
import React from 'react';
import { PlaylistCard } from '@/components/collections/PlaylistCard';

interface PopularCollectionsTabProps {
  playlists: any[] | null;
  isLoading: boolean;
}

export const PopularCollectionsTab = ({ playlists, isLoading }: PopularCollectionsTabProps) => {
  if (isLoading) return null;

  if (!playlists?.length) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-semibold mb-2">No popular collections found</h3>
        <p className="text-gray-600">
          Try adjusting your filters or check back later
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {playlists.map((playlist) => {
        // Make sure we're passing the places_count as a number, not an object
        const placesCount = typeof playlist.places_count === 'object' && playlist.places_count.count !== undefined 
          ? playlist.places_count.count 
          : (typeof playlist.places_count === 'number' ? playlist.places_count : 0);
        
        return (
          <PlaylistCard 
            key={playlist.id}
            id={playlist.id}
            name={playlist.name}
            description={playlist.description}
            placesCount={placesCount}
            creatorName={playlist.created_by_user?.username}
            creatorAvatar={playlist.created_by_user?.avatar_url}
            image={playlist.image}
            city={playlist.city}
            country={playlist.country}
            placeItems={playlist.place_items || []}
          />
        );
      })}
    </div>
  );
};
